module.exports = __webpack_public_path__ + "static/media/365.1bda8f19.svg";